import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
declare var bootstrap: any;

interface ExportField {
  key: string;
  label: string;
  selected: boolean;
}

@Component({
  selector: 'app-shipping-export-fields-modal',
  templateUrl: './shipping-export-fields-modal.component.html',
  styleUrls: ['./shipping-export-fields-modal.component.scss']
})
export class ShippingExportFieldsModalComponent extends DestructorComponent implements OnInit {

  @Output() exportRequested = new EventEmitter<string[]>();

  // All available fields from the shipping table
  availableFields: ExportField[] = [
    { key: 'stock_number', label: 'Stock Number', selected: true },
    { key: 'chassis_number', label: 'Chassis Number', selected: true },
    { key: 'book_request_date', label: 'Book Request Date', selected: true },
    { key: 'paid_percentage', label: 'Paid %', selected: true },
    { key: 'sales_agent', label: 'Sales Agent', selected: true },
    { key: 'agent_notes', label: 'Agent Notes', selected: true },
    { key: 'yard_name', label: 'Yard Name', selected: true },
    { key: 'yard_date', label: 'Yard Date', selected: true },
    { key: 'destination_port', label: 'Destination Port', selected: true },
    { key: 'destination_country', label: 'Destination Country', selected: true },
    { key: 'masho_date', label: 'Masho Date', selected: true },
    { key: 'ship_type', label: 'Ship Type', selected: true },
    { key: 'group_number', label: 'Group Number', selected: true },
    { key: 'ship_confirm_date', label: 'Ship Confirm Date', selected: true },
    { key: 'status', label: 'Status', selected: true },
    { key: 'ship_id', label: 'Ship Id', selected: true },
    { key: 'ship_name', label: 'Ship Name', selected: true },
    { key: 'voyage_number', label: 'Voyage Number', selected: true },
    { key: 'carrier_name', label: 'Carrier Name', selected: true },
    { key: 'sailing_port', label: 'Sailing Port', selected: true },
    { key: 'sailing_date', label: 'Sailing Date', selected: true },
    { key: 'arrival_date', label: 'Arrival Date', selected: true },
    { key: 'customer_name', label: 'Customer Name', selected: true },
    { key: 'terms', label: 'Terms', selected: true },
    { key: 'invoice_amount', label: 'Invoice Amount', selected: true },
    { key: 'currency', label: 'Currency', selected: true },
    { key: 'model_name', label: 'Model Name', selected: true },
    { key: 'make', label: 'Make', selected: true },
    { key: 'vehicle_status', label: 'Vehicle Status', selected: true },
    { key: 'length_cm', label: 'L (cm)', selected: true },
    { key: 'width_cm', label: 'W (cm)', selected: true },
    { key: 'height_cm', label: 'H (cm)', selected: true },
    { key: 'weight', label: 'Weight', selected: true },
    { key: 'm3', label: 'M3', selected: true },
    { key: 'inspection_type', label: 'Inspection Type', selected: true },
    { key: 'inspection_apply_date', label: 'Inspection Apply Date', selected: true },
    { key: 'inspection_status', label: 'Inspection Status', selected: true },
    { key: 'inspection_pass_date', label: 'Inspection Pass Date', selected: true },
    { key: 'repair_status', label: 'Repair Status', selected: true },
    { key: 'repair_comp_date', label: 'Repair Comp Date', selected: true },
    { key: 'container_no', label: 'Container No', selected: true },
    { key: 'bl_number', label: 'Bl Number', selected: true },
    { key: 'vanning', label: 'Vanning', selected: true },
    { key: 'seal_number', label: 'Seal Number', selected: true },
    { key: 'freight_paid_date', label: 'Freight Paid Date', selected: true },
    { key: 'shipping_mark', label: 'Shipping Mark', selected: true },
    { key: 'auction_name', label: 'Auction Name', selected: true },
    { key: 'created_by', label: 'Created By', selected: true },
    { key: 'lot_number', label: 'Lot Number', selected: true },
    { key: 'purchase_date', label: 'Purchase Date', selected: true },
    { key: 'remark', label: 'Remark', selected: true },
    { key: 'btc_days', label: 'BTC Days', selected: true },
    { key: 'paid', label: 'Paid', selected: true },
    { key: 'balance', label: 'Balance', selected: true },
    { key: 'age', label: 'Age', selected: true },
    { key: 'paid_date', label: 'Paid Date', selected: true }
  ];

  selectAll: boolean = true;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.setupModalListener();
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_shipping_export_fields');
    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', () => {
        // Reset to all selected when modal opens
        this.selectAll = true;
        this.availableFields.forEach(field => field.selected = true);
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        // Optional: Reset state when modal closes
      });
    }
  }

  toggleSelectAll(): void {
    this.availableFields.forEach(field => field.selected = this.selectAll);
  }

  onFieldToggle(): void {
    // Update selectAll checkbox state based on individual selections
    this.selectAll = this.availableFields.every(field => field.selected);
  }

  getSelectedCount(): number {
    return this.availableFields.filter(field => field.selected).length;
  }

  onGenerateExcel(): void {
    const selectedFields = this.availableFields
      .filter(field => field.selected)
      .map(field => field.key);

    if (selectedFields.length === 0) {
      return;
    }

    // Emit the selected fields to parent component
    this.exportRequested.emit(selectedFields);

    // Close the modal
    this.closeModal();
  }

  closeModal(): void {
    const modalElement = document.getElementById('kt_modal_shipping_export_fields');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }
}
